export const formatNum4Dp = (number) => {
  if (number) {
    return parseFloat(number).toFixed('4')
  }
  return '0'
}

export default formatNum4Dp
